// Pure helpers for the Executive summary: the headline sentence, how each number changed, and the comparison table.
export const GRADE_COLOR = { A: '#22c55e', B: '#84cc16', C: '#f59e0b', D: '#f97316', F: '#ef4444' };
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

// +3 / -3 / "no change", and whether that is good news (null when it is neutral).
export function change(before, now, { lowerIsBetter = true, unit = '' } = {}) {
  if (before == null || now == null) return { text: '-', good: null };
  const d = Math.round((now - before) * 10) / 10;
  if (d === 0) return { text: 'no change', good: null };
  return { text: `${d > 0 ? '+' : ''}${d}${unit}`, good: lowerIsBetter ? d < 0 : d > 0 };
}

// One headline sentence and one supporting sentence, from real numbers only.
export function verdict(data) {
  const { now, previous, current_window: cur } = data;
  const serious = now.critical_high;
  const trend = serious < previous.critical_high ? 'falling' : serious > previous.critical_high ? 'rising' : 'steady';
  const good = trend !== 'rising';
  const head = `Risk is ${trend}${serious ? `, but ${plural(serious, 'serious problem is', 'serious problems are')} still open` : ', and nothing serious is open'}.`
    .replace(', but', trend === 'rising' ? ', and' : ', but');
  const parts = [`${plural(cur.fixed, 'problem was', 'problems were')} fixed in the last 30 days and ${cur.new} new ${cur.new === 1 ? 'one' : 'ones'} appeared.`];
  if (cur.overdue_cases) parts.push(`${plural(cur.overdue_cases, 'fix is', 'fixes are')} past the deadline.`);
  return { good, trend, head, detail: parts.join(' ') };
}

export const gradeNote = (data) => (data.now.grade === data.previous.grade ? `same as 30 days ago` : `from ${data.previous.grade} 30 days ago`);
export const gradeImproved = (data) => data.now.score > data.previous.score;

// Rows for the "last period vs this period" table.
export function comparisonRows(data) {
  const { now, previous, current_window: c, previous_window: p } = data;
  const days = (v) => (v == null ? '-' : `${v} d`);
  return [
    { label: 'Open findings', before: previous.total, now: now.total, ...change(previous.total, now.total) },
    { label: 'Critical and high', before: previous.critical_high, now: now.critical_high, ...change(previous.critical_high, now.critical_high) },
    { label: 'Fixed in the period', before: p.fixed, now: c.fixed, ...change(p.fixed, c.fixed, { lowerIsBetter: false }) },
    { label: 'New in the period', before: p.new, now: c.new, ...change(p.new, c.new) },
    { label: 'Average time to fix', before: days(p.avg_days_to_fix), now: days(c.avg_days_to_fix), ...change(p.avg_days_to_fix, c.avg_days_to_fix, { unit: ' d' }) },
    { label: 'Overdue fixes', before: p.overdue_cases, now: c.overdue_cases, ...change(p.overdue_cases, c.overdue_cases) },
    { label: 'Scans run', before: p.scans, now: c.scans, ...change(p.scans, c.scans, { lowerIsBetter: false }) }
  ];
}
